$(document).ready(function() {
  initHomepageSlider();
	// initHomeSlider();
	initInputSearchHome();
	init_modals();

	/* ==============================================
		Menu
	=============================================== */

	$('a.open_close').on("click", function () {
		$('.main-menu').toggleClass('show');
		$('.layer').toggleClass('layer-is-visible');
	});
	$('a.show-submenu').on("click", function () {
		$(this).next().toggleClass("show_normal");
	});
	$('a.show-submenu-mega').on("click", function () {
		$(this).next().toggleClass("show_mega");
	});
	if ($(window).width() <= 480) {
		$('a.open_close').on("click", function () {
			$('.cmn-toggle-switch').removeClass('active')
		});
	}

	/* Collapse filters */
	if ($(this).width() < 991) {
		$('.collapse#collapseFilters').removeClass('in');
		$('.collapse#collapseFilters').addClass('out');
	} else {
		$('.collapse#collapseFilters').removeClass('out');
		$('.collapse#collapseFilters').addClass('in');
	}

});

function stickySidebar(){
	$('#sidebar').theiaStickySidebar({
  	additionalMarginTop: 80
  });
}

function initHomepageSlider(){
  if($('.homepage-banner').length > 0){
    $('.homepage-banner').slick({
      lazyLoad: 'ondemand',
      dots: false,
      arrows: true,
      infinite: true,
      // speed: 300,
      autoplay: true,
      // autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.banner-nav .banner-button-prev'),
      nextArrow: $('.banner-nav .banner-button-next')
    });
  }
}

function initHomeSlider() {
	if($('.tp-banner').length > 0)
	{
		$('.tp-banner').show().revolution({
	    dottedOverlay: "none",
	    delay: 3000,
	    startwidth: 1170,
	    startheight: 550,
	    hideThumbs: 200,

	    thumbWidth: 100,
	    thumbHeight: 50,
	    thumbAmount: 5,

	    navigationType: "bullet",
	    navigationArrows: "solo",
	    navigationStyle: "none",

	    touchenabled: "on",
	    onHoverStop: "on",

	    swipe_velocity: 0.7,
	    swipe_min_touches: 1,
	    swipe_max_touches: 1,
	    drag_block_vertical: false,

	    parallax: "mouse",
	    parallaxBgFreeze: "on",
	    parallaxLevels: [7, 4, 3, 2, 5, 4, 3, 2, 1, 0],

	    keyboardNavigation: "off",

	    navigationHAlign: "center",
	    navigationVAlign: "bottom",
	    navigationHOffset: 0,
	    navigationVOffset: 20,

	    soloArrowLeftHalign: "left",
	    soloArrowLeftValign: "center",
	    soloArrowLeftHOffset: 20,
	    soloArrowLeftVOffset: 0,

	    soloArrowRightHalign: "right",
	    soloArrowRightValign: "center",
	    soloArrowRightHOffset: 20,
	    soloArrowRightVOffset: 0,

	    shadow: 0,
	    fullWidth: "on",
	    fullScreen: "off",

	    spinner: "spinner4",

	    stopLoop: "off",
	    stopAfterLoops: -1,
	    stopAtSlide: -1,

	    shuffle: "off",

	    autoHeight: "off",
	    forceFullWidth: "on",

	    hideThumbsOnMobile: "off",
	    hideNavDelayOnMobile: 1500,
	    hideBulletsOnMobile: "off",
	    hideArrowsOnMobile: "on",
	    hideThumbsUnderResolution: 0,

	    hideSliderAtLimit: 0,
	    hideCaptionAtLimit: 480,
	    hideAllCaptionAtLilmit: 480,
	    startWithSlide: 0,
	    videoJsPath: "rs-plugin/videojs/",
	    fullScreenOffsetContainer: ""
	  });
	}
}

function initInputSearchHome() {
	if($('.date-pick').length > 0) {
		$('input.date-pick').datepicker({
			format: "yyyy/mm",
			startView: "year", 
			minViewMode: "months",
			startDate: "today",
			todayHighlight:'TRUE',
			endDate:0,
			autoclose: true
	  });
	}

  if($('.time-pick').length > 0)
  {
	  $('input.time-pick').timepicker({
	    minuteStep: 15,
	    showInpunts: false
	  })
  }
}

window.formValidator2 = function(){
	var youremail = document.theForm2.youremail.value;
	
	if(document.theForm2.youremail.value==""||document.theForm2.youremail.value.replace(/^\s+|\s+$/g, '')==""){
		//document.getElementById("status111").innerHTML="<font color='red'><img src='cross.png' />&nbsp;Value cannot be empty!</font>";
		alert("Invalid Email!");
		document.getElementById("youremail").focus();
		return false;
	}else {
		//document.getElementById("status111").innerHTML="";
	}
	if(!validateemail2(document.theForm2.youremail.value)){
  	return false;
	};
}

function validateemail2(email){
	if(email.indexOf("@")==-1){
    	alert("You have entered an invalid email. Please enter again.");	
		document.theForm.login_id.focus();
		return false;
  	}else{  
    	if(email.indexOf(".")==-1){
	 		alert("Your email is not complete.");
	  		document.theForm.login_id.focus();
	  		return false;
		}else{
	  		if(email.substr(email.lastIndexOf("."),3).length<3){
	    		alert("Your email is not yet complete.");
	    		document.theForm.login_id.focus();
	    		return false;
      		};  		
		};
  	};
 	return true;
};

window.init_click_tour_category = function() {
  // alert("----------------------");
  if($('#cat1').length > 0)
  {
	  var cat1 = document.getElementById("cat1");
	  var cat2 = document.getElementById("cat2");
		// var cat3 = document.getElementById("cat3");
		var catvalue1="";
		var catvalue2="";
		// var catvalue3="";
		var firstname_booking = document.getElementById("firstname_booking").value;
		var datesearch = document.getElementById("datesearch").value;
		// alert("----------------------"+firstname_booking);
		if (cat1.checked == true){
	    var catvalue1="GD Standard";
			//alert("----------------------"+catvalue1);
	  } 
	  
	  if (cat2.checked == true){
	    var catvalue2="GD Premium";
	  } 
	 	alert('here');
	  
	  if (cat1.checked != true && cat2.checked != true){
	  	alert("Error! you have to choose either one of the tour category!");
	  	return false;
	  }
	/*  if (cat3.checked == true){
	    var catvalue3="Four Season";
	  }*/
	 // window.location = 'https://netsoftsystem.com.my/gdweb/search/1';
	 //$('#changefilter').html("-----------------------------");


	  $.ajax({
			url:'/filter.php?catvalue1='+catvalue1+'&catvalue2='+catvalue2+'&firstname_booking='+firstname_booking+'&datesearch='+datesearch,
			type:'GET',
			success: function(data){
			   $('#changefilter').html(data);
			}
		});
  }
}

window.init_onchange_state = function(){
	if($('#state').length > 0)
	{
	  var state = document.getElementById("state").value;
	  $.ajax({
	    url:'/engine_refreshform3.php?state='+state,
	    type:'GET',
	    success: function(data){
	       $('#refresh_city').html(data);
	    }
	  });
	}
}

window.init_modals = function () {
	init_modal_agent_detail();
}

function init_modal_agent_detail(){
	$('.modal-agent-detail').click(function() {
	  let modal_agent_id = $(this).data('id');
	  $.ajax({
	    url:'/public/views/modal/agent-detail.php?modal_agent_id='+modal_agent_id,
	    type:'GET',
	    success: function(data){
	      if(data!=='failed')
	      {
	        $('#modalAgentDetailHidden').empty().html(data);
	        $('#modalAgentWrapper').modal('show');

     			// var modalAgentWrapperCloseBtn = document.getElementsByClassName("close-modal-btn")[0];
					// modalAgentWrapperCloseBtn.onclick = function() {
					//   modalAgentWrapper.display.style = 'none';
					// }

        	var modalAgentWrapper = $("#modalAgentWrapper");
					$(window).click(function(e) {
						if(modalAgentWrapper.length > 0){
							modalAgentWrapper.modal('hide');
				  	}
					});
	      }
	    }
		});
	});
}